module.exports = __webpack_public_path__ + "media/images/common/2column_product_bg_yyy-89f95e4365c5aa4787057dcb2c8700a9.png";